import React, { Component } from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import qs from "qs";
import update from "immutability-helper";
import moment from 'moment';
import {Link} from 'react-router-dom';
import _ from "lodash";
import {
    Table,
    Segment,
    Breadcrumb,
    Button,
    Input,
    Label,
    Icon,
    Modal,
    Checkbox
} from "semantic-ui-react";
import TableFilter from "../utils/tables/TableFilter";
import OrderByHeader from "../utils/tables/OrderByHeader";
import TablePagination from "../utils/tables/TablePagination";
import {api} from '../../api';
import Dls from "../../lib";
import {
    fetchTransactions,
    updateDocNumber,
    setDocModelInStore,
    updateInvoiceNumberInModel
} from '../../actions/shipment';

class QbTransactionListPage extends Component {
    constructor() {
        super();
        this.state = {
            routing: {
                params: {
                    in_qb: 1,
                    on_page: 1,
                    per_page: 15,
                    search: '',
                    filters: {
                        acct_type: 'All'
                    },
                    order_by: {
                        created_at: 'desc'
                    }
                },
                path: ""
            },
            filters: {
                acct_type: []
            },
            acctNumberModal: false,
            exportIds: {},
            exportBtnDisabled: false,
            invoiceIds: {},
            invoiceBtnDisabled: false
        };
    }

    componentDidMount() {
        const { params } = this.props.match;
        this.setQueryParamsFromPath(params.params);
    }

    componentWillReceiveProps(props) {
        const { params } = props.match;
        this.setQueryParamsFromPath(params.params);
    }

    setQueryParamsFromPath = (path) => {
        if (this.state.routing.path !== path) {
            const params = qs.parse(path);
            const { filters } = params;
            let defaultAcctTypeFilter = [];
            if (_.isObject(filters)) {
                if (filters.acct_type) {
                    defaultAcctTypeFilter = filters.acct_type.split(",");
                }
            }

            this.setState({
                routing: { params, path },
                filters: {
                    acct_type: defaultAcctTypeFilter
                }
            }, () => {
                this.fetchRecords();
            });
        }
    };

    fetchRecords = () => {
        this.setState({
            exportIds: {},
            exportBtnDisabled: false,
            invoiceIds: {},
            invoiceBtnDisabled: false
        });
        const {jwt} = this.props;
        const {params} = this.state.routing;
        this.props.fetchTransactions(jwt, qs.stringify(params)).catch(err => {
            Dls.apiErrorAlert(err);
        });;
    };

    runSearch = () => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    on_page: { $set: 1 }
                })
            }
        }, () => {
            this.routeTo();
        });
    };

    routeTo = () => {
        this.setState({
            exportIds: {},
            exportBtnDisabled: false
        });
        this.props.history.push(`/qb/transactions/${qs.stringify(this.state.routing.params)}`);
    }

    _onTableHeaderSort = (field, value) => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    order_by: {
                        [field]: {$set: value}
                    }
                })
            }
        }, () => {
            this.routeTo();
        });
    };

    _handleKeyPress = e => {
        if (e.key === "Enter") {
            this.runSearch();
        }
    };

    _onSearchChange = e => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    search: { $set: e.target.value }
                })
            }
        });
    };

    _onAcctTypeDropdownSelectChange = (e, data) => {
        const { value } = data;
        this.setState({
            filters: update(this.state.filters, {
                acct_type: { $set: value }
            })
        });
        this.setState({
            routing: update(this.state.routing, {
                params: {
                    filters: {
                        acct_type: {$set: value.join()}
                    }
                }
            })
        })
    };

    goToPage = (page) => {
        this.setState({
            routing: {
                params: update(this.state.routing.params, {
                    on_page: { $set: page }
                })
            }
        }, () => {
            this.routeTo();
        });
    }

    getRouteType = (acctType) => {
        if (acctType === 'Invoice' || acctType === 'Vendor Credit')
        {
            return 'outbound';
        }

        if (acctType === 'Bill' || acctType === 'Credit Memo')
        {
            return 'inbound';
        }
    }

    onOpenDocNumberModalClick = (i) => {
        this.props.setDocModelInStore(i);
        this.setState({
            acctNumberModal: true
        });
    }

    onAcctNumberModalClose = () => {
        this.setState({
            acctNumberModal: false
        });
    }

    updateInvoiceNum = () => {
        const {jwt} = this.props;
        const {id, invoice_number} = this.props.model;
        this.props.updateDocNumber(jwt, id, invoice_number).then( res => {
            this.onAcctNumberModalClose();
        }).catch(err => {
            Dls.apiErrorAlert(err);
        });
    }

    _isTableRowChecked = (i) => {
        const {id} = i;
        if (this.state.exportIds[id]) {
            return true;
        }
        return false;
    }

    _onExportCheckboxClicked = (i) => {
        const {id} = i;
        const b = _.cloneDeep(this.state.exportIds);
        if (b[id]) {
            delete(b[id])
        } else {
            b[id] = id
        }
        this.setState({
            exportIds: b
        });
    }

    _isInvoiceTableRowChecked = (i) => {
        const {id} = i;
        if (this.state.invoiceIds[id]) {
            return true;
        }
        return false;
    }

    _onInvoiceCheckboxClicked = (i) => {
        const {id} = i;
        const b = _.cloneDeep(this.state.invoiceIds);
        if (b[id]) {
            delete(b[id])
        } else {
            b[id] = id
        }
        this.setState({
            invoiceIds: b
        });
    }

    onQbExportClicked = () => {
        const ids = Object.values(this.state.exportIds);
        this.setState({
            exportBtnDisabled: true
        });
        api.shipment.exportToQb(this.props.jwt, ids).then(res => {
            this.fetchRecords();
        }).catch(err => {
            this.setState({
                exportBtnDisabled: false
            });
            Dls.apiErrorAlert(err);
        })
    }

    onInvoiceSendClicked = () => {
        const ids = Object.values(this.state.invoiceIds);
        this.setState({
            invoiceBtnDisabled: true
        });
        api.email.invoice(this.props.jwt, ids).then(res => {
            Dls.success("Emails are quened, please check back later");
            this.setState({
                invoiceIds: {},
                invoiceBtnDisabled: false
            });
        }).catch(err => {
            Dls.apiErrorAlert(err);
            this.setState({
                invoiceBtnDisabled: false
            });
        })
    }
    
    canEditInvoiceNum = (i) => {
        if (i.acct_id) {
            return false;
        }
        if (i.acct_type === 'Bill') {
            return true;
        }
        if (i.acct_type === 'Vendor Credit') {
            return true;
        }
        return false;
    }

    render() {
        const {list} = this.props;
        return (
            <div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-8">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                QB
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                Transactions
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                    <div className="col-md-4">
                    
                    </div>
                </div>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-12">
                        <Segment>
                            <div className="col-md-12">
                                <Input
                                    placeholder="Search QB ref #, order # or order ref #"
                                    size="mini"
                                    action
                                    onKeyPress={this._handleKeyPress}
                                    onChange={this._onSearchChange}
                                    value={this.state.routing.params.search}
                                    fluid
                                >
                                    <input />
                                    <Button
                                        icon="filter"
                                        onClick={() => {this.runSearch()}}
                                        type="button"
                                        color="pink"
                                    />
                                </Input>
                            </div>
                            <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-8" style={{marginTop: "5px"}}>
                                    <TableFilter
                                        name="AcctType"
                                        options={[
                                            {text:'All',value:'All',key:'All'},
                                            {text:'Invoice',value:'Invoice',key:'Invoice'},
                                            {text:'Bill',value:'Bill',key:'Bill'},
                                            {text:'Credit Note',value:'Credit Note',key:'Credit Note'},
                                            {text:'Vendor Credit',value:'Vendor Credit',key:'Vendor Credit'}
                                        ]}
                                        selectedValues={
                                            this.state.filters.acct_type
                                        }
                                        onDropdownSelectChange={(e, data) => {
                                            this._onAcctTypeDropdownSelectChange(
                                                e,
                                                data
                                            );
                                        }}
                                        placeHolder="Filter by accounting type"
                                    />
                                </div>
                                <div className="col-md-4" style={{marginTop: "15px"}}>
                                    <Checkbox 
                                        label="Show Un-synchronized Only"
                                        checked={parseInt(this.state.routing.params.in_qb, 10) === 1 ? false : true}
                                        onClick={(e, data) => {
                                            this.setState({
                                                routing: update(this.state.routing, {
                                                    params: {
                                                        in_qb: {$set: data.checked ? 0 : 1}
                                                    }
                                                })
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                            </div>
                        </Segment>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Table compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        {_.isEmpty(this.state.exportIds) ? 'QB' : 
                                            <Button 
                                                size='mini' 
                                                disabled={this.state.exportBtnDisabled}
                                                color='teal'
                                                onClick={() => this.onQbExportClicked()}>Export {Object.keys(this.state.exportIds).length}</Button>}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        {_.isEmpty(this.state.invoiceIds) ? 'Email' : 
                                            <Button 
                                                size='mini' 
                                                disabled={this.state.invoiceBtnDisabled}
                                                color='teal'
                                                onClick={() => this.onInvoiceSendClicked()}>Email {Object.keys(this.state.invoiceIds).length}</Button>}
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Order Ref
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <OrderByHeader
                                            headerName='Doc Number'
                                            currentValue={
                                                this.state.routing.params
                                                    .order_by.invoice_number
                                                    ? this.state.routing.params
                                                          .order_by.invoice_number
                                                    : ""
                                            }
                                            field="invoice_number"
                                            onSortListChange={(
                                                field,
                                                value
                                            ) => {
                                                this._onTableHeaderSort(
                                                    field,
                                                    value
                                                );
                                            }}
                                        />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Doc Type
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Relation
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        QB
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        Invoice
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <OrderByHeader
                                            headerName='Updated On'
                                            currentValue={
                                                this.state.routing.params
                                                    .order_by.updated_at
                                                    ? this.state.routing.params
                                                          .order_by.updated_at
                                                    : ""
                                            }
                                            field="updated_at"
                                            onSortListChange={(
                                                field,
                                                value
                                            ) => {
                                                this._onTableHeaderSort(
                                                    field,
                                                    value
                                                );
                                            }}
                                        />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        View
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {_.isArray(list.data) ? list.data.map(i => {
                                    return <Table.Row key={i.id}>
                                        <Table.Cell>
                                            {i.acct_id ? null : 
                                                <Checkbox 
                                                    checked={this._isTableRowChecked(i)}
                                                    onClick={() => {this._onExportCheckboxClicked(i)}}/>}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.acct_id && !i.invoice_sent && i.relation_name.email && (i.acct_type === 'Invoice' || i.acct_type === 'Credit Memo')? <Checkbox 
                                                    checked={this._isInvoiceTableRowChecked(i)}
                                                    onClick={() => {this._onInvoiceCheckboxClicked(i)}}/> : null}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.order.so}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {!this.canEditInvoiceNum(i) ? i.invoice_number : 
                                                <a href='javascript:;' onClick={() => {this.onOpenDocNumberModalClick(i)}}>
                                                    {i.invoice_number ? i.invoice_number : 'Enter'}
                                                </a>}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.acct_type}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.relation_name ? i.relation_name.company_name : ""}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {!i.acct_id ? <Label color='orange' size='mini'>
                                                <Icon name='minus' />
                                            </Label> : null}
                                            {i.acct_id ? <Label color='green' size='mini'>
                                                <Icon name='checkmark' />
                                            </Label> : null}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {(!i.invoice_sent && i.relation_name.email && (i.acct_type === 'Invoice' || i.acct_type === 'Credit Memo')) ? <Label color='orange' size='mini'>
                                                <Icon name='minus' /> 
                                            </Label> : null}
                                            {(i.invoice_sent && i.relation_name.email && (i.acct_type === 'Invoice' || i.acct_type === 'Credit Memo')) ? <Label color='green' size='mini'>
                                                <Icon name='checkmark' />
                                            </Label> : null}
                                            {!i.relation_name.email ? <Label color='grey' size='mini'>NA</Label> : null}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {i.updated_at}
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Link to={`/shipments/${this.getRouteType(i.acct_type)}/${i.id}/view`}>
                                                View
                                            </Link>
                                        </Table.Cell>
                                    </Table.Row>
                                }) : null}
                            </Table.Body>
                        </Table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12" style={{marginTop: '5px'}}>
                        <TablePagination
                            goToPage={(page) => {this.goToPage(page);}}
                            on_page={list.on_page}
                            total_records={list.total_count}
                            per_page={list.per_page} />
                    </div>
                </div>
            
                <Modal size='mini' open={this.state.acctNumberModal} onClose={this.onAcctNumberModalClose} closeOnDimmerClick={false}>
                    <Modal.Header>Set Document Number: {this.props.model.order ? this.props.model.order.so : ""}</Modal.Header>
                    <Modal.Content>
                        <Input
                            size="mini"
                            onChange={(e) => {this.props.updateInvoiceNumberInModel(e.target.value)}}
                            value={!this.props.model.invoice_number ? "" : this.props.model.invoice_number}
                            fluid
                        />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.onAcctNumberModalClose}>Cancel</Button>
                        <Button positive icon='checkmark' labelPosition='right' content='Save' onClick={() => {this.updateInvoiceNum()}}/>
                    </Modal.Actions>
                </Modal>
            </div>
        )
    }
}

QbTransactionListPage.propTypes = {
    history: PropTypes.shape({
       push: PropTypes.func.isRequired
    }).isRequired,
    fetchTransactions: PropTypes.func.isRequired,
    updateDocNumber: PropTypes.func.isRequired,
    setDocModelInStore: PropTypes.func.isRequired,
    updateInvoiceNumberInModel: PropTypes.func.isRequired,
    list: PropTypes.object.isRequired,
    jwt: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        jwt: state.auth.jwt,
        list: state.shipment.transaction_list,
        model: state.shipment.qb_bill
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchTransactions,
        updateDocNumber,
        setDocModelInStore,
        updateInvoiceNumberInModel
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(QbTransactionListPage)


// WEBPACK FOOTER //
// ./src/components/shipments/QbTransactionList.js